var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiltericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 18,
    viewBox: "0 0 30 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.25C10 15.9185 10.1317 15.6005 10.3661 15.3661C10.6005 15.1317 10.9185 15 11.25 15H18.75C19.0815 15 19.3995 15.1317 19.6339 15.3661C19.8683 15.6005 20 15.9185 20 16.25C20 16.5815 19.8683 16.8995 19.6339 17.1339C19.3995 17.3683 19.0815 17.5 18.75 17.5H11.25C10.9185 17.5 10.6005 17.3683 10.3661 17.1339C10.1317 16.8995 10 16.5815 10 16.25ZM5 8.75C5 8.41848 5.1317 8.10054 5.36612 7.86612C5.60054 7.6317 5.91848 7.5 6.25 7.5H23.75C24.0815 7.5 24.3995 7.6317 24.6339 7.86612C24.8683 8.10054 25 8.41848 25 8.75C25 9.08152 24.8683 9.39946 24.6339 9.63388C24.3995 9.8683 24.0815 10 23.75 10H6.25C5.91848 10 5.60054 9.8683 5.36612 9.63388C5.1317 9.39946 5 9.08152 5 8.75ZM0 1.25C0 0.918479 0.131696 0.600537 0.366117 0.366117C0.600537 0.131696 0.918479 0 1.25 0H28.75C29.0815 0 29.3995 0.131696 29.6339 0.366117C29.8683 0.600537 30 0.918479 30 1.25C30 1.58152 29.8683 1.89946 29.6339 2.13388C29.3995 2.3683 29.0815 2.5 28.75 2.5H1.25C0.918479 2.5 0.600537 2.3683 0.366117 2.13388C0.131696 1.89946 0 1.58152 0 1.25Z",
    fill: "#8B8989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltericon);
export default __webpack_public_path__ + "static/media/filtericon.5fca1860eb4df948d1d0756ee9b5f3b9.svg";
export { ForwardRef as ReactComponent };